import * as React from "react";
const SvgBlank = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "transparent", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 0.5, y: 0.5, width: 23, height: 23, rx: 3.5, stroke: "currentColor" }));
export default SvgBlank;
